"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignIn = void 0;
const mithril_1 = __importDefault(require("mithril"));
const auth_1 = require("../../utils/auth");
const form_for_1 = require("../../widgets/form_for");
const LoginForm = {
    error: false,
    errorMessage: undefined,
    email: "",
    password: "",
    keepConnected: false,
};
const handleClick = (e) => {
    e.preventDefault();
    auth_1.Auth.auth(LoginForm);
};
const errorBox = (login) => {
    if (login.error) {
        return (0, mithril_1.default)("div", { class: "notification is-danger" }, (0, mithril_1.default)("button", { class: "delete", onclick: (e) => { e.preventDefault(); login.error = false; } }), (login.errorMessage ? login.errorMessage : (login.error == 403 ? "Email ou mot de passe incorrecte" : "Erreur du serveur. Veuillez rééssayer plus tard.")));
    }
    else {
        return undefined;
    }
};
const signInBox = () => {
    return (0, mithril_1.default)("div", { class: "form container is-fluid" }, (0, mithril_1.default)("form", errorBox(LoginForm), (0, mithril_1.default)("div", { style: "text-align: center" }, (0, mithril_1.default)("img", { src: "/logo_sesame_bw.svg" })), (0, form_for_1.field)("Email", "email", "email", LoginForm, {}), (0, form_for_1.field)("Mot de passe", "password", "password", LoginForm, {}), (0, form_for_1.checkbox)(" rester connecté", "keepConnected", LoginForm, {}), (0, mithril_1.default)("p", (0, mithril_1.default)("a", { href: "#/forgot-password" }, "J'ai oublié mon mot de passe")), (0, mithril_1.default)("div", { style: "margin-top: 1em;" }, (0, mithril_1.default)("button.button.is-primary", { onclick: handleClick }, "Se connecter"))));
};
exports.SignIn = {
    view() {
        return (0, mithril_1.default)("div", { class: "sign-in" }, signInBox());
    }
};
